import React from 'react'

const ArrowDownScroll = () => {
  return (
    <svg width="92px" height="92px" viewBox="0 0 92 92">
      <g  stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g  transform="translate(-674.000000, -825.000000)" fillRule="nonzero" strokeWidth="2">
          <g  transform="translate(675.000000, 826.000000)">
            <circle stroke="#3F5063" cx="45" cy="45" r="45"></circle>
            <polyline stroke="#6EC18A" strokeLinecap="round" strokeLinejoin="round"
                      transform="translate(45.000000, 58.000000) rotate(-45.000000) translate(-45.000000, -58.000000)"
                      points="55 68 35 68 35 48 35 48"></polyline>
          </g>
        </g>
      </g>
    </svg>
  )
};

export default ArrowDownScroll
